import * as React from 'react';

const SvgChevronTopOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "m12 9.832 5.582 5.61L19 14.033 12 7l-7 7 1.415 1.414L12 9.832Z", fill: "currentColor" })));

export { SvgChevronTopOutline as default };
